import styles from './PageHeader.module.scss';
import { Props } from './PageHeader.types';

const PageHeader = ({ label, rightElement, onLabelClick }: Props) => {
  return (
    <div className={styles.pageHeaderContainer}>
      {onLabelClick ? (
        <button className={styles.pageHeaderClickable} onClick={onLabelClick}>
          {label}
        </button>
      ) : (
        <div className={styles.pageHeader}>{label}</div>
      )}
      {rightElement}
    </div>
  );
};

export default PageHeader;
